<div class="view-dialog-container" *ngIf="userData as user">
    <div class="header-container">
        <div class="header-tittle">View csq user details</div>
        <div class="cros-icon" (click)="onCancel()">
            <img src="assets/images/cross-icon.svg" class="cross-icon" />
        </div>
    </div>

    <div class="p-3 d-grid gap-4">
        <div class="user-details">
            <div class="d-flex align-items-center gap-3">
                <div>
                    <img class="user-profile" [src]="user.profilePicture || 'assets/images/avatar-default.png'"
                        alt="User Profile" />
                </div>
                <div class="d-grid gap-2">
                    <span
                        [ngClass]="user.status === 'Active' ? 'status-active' : user.status === 'Inactive' ? 'status-inactive' : 'status-pending'"
                        style="cursor: default;"
                        >
                        {{ user?.status }}
                    </span>
                    <div>{{ user?.roleName }}</div>
                </div>
            </div>
        </div>

        <div class="teacher-card">

            <div class="details-section">
                <div class="d-grid gap-2">
                    <div class="secondary-text">First name</div>
                    <div class="main-text">{{ getFirstName(user) }}</div>
                </div>
                <!-- <div class="border-side"></div> -->
                <div class="d-grid gap-2">
                    <div class="secondary-text">Last name</div>
                    <div class="main-text">{{ getLastName(user)}}</div>
                </div>

            </div>

            <div class="details-section-second">
                <div class="d-grid gap-2">
                    <div class="secondary-text">Phone number</div>
                    <div class="main-text">{{ getPhoneNumber(user)}}</div>
                </div>
                <!-- <div class="border-side"></div> -->
                <div class="d-grid gap-2">
                    <div class="secondary-text">Email</div>
                    <div class="main-text">{{ user?.email || '-' }}</div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!userData" class="d-grid justify-content-center">
        <!-- <div class="d-flex justify-content-center">
            <dotlottie-player src="https://lottie.host/26873423-6dfd-4401-8d29-30cbf13adc4e/vEF6VT4Oa0.lottie"
                background="transparent" speed="1" style="width: 300px; height: 300px" loop autoplay></dotlottie-player>
        </div> -->
        <span class="loading-text text-center">Loading data...</span>
    </div>
</div>